import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import { formatDate, creatDownload } from '@/utils/formUtils'
import {
  compare,
  getdayType,
  cycleChange
} from 'enumeration/lab-order.js'
import orderDatas from '@/store/actions/datas/order'
import { sampleType } from 'json/goods-order-options'
import { getEnumeration } from 'enumeration'
import orderflowHelper from '@/config/order'
import { getPlateType } from '@/utils/plateType'
import billDatas from '@/store/actions/datas/bill'
export default {
  getLabOrderList (ctx, data) {
    let arr = Object.keys(data)
    arr.forEach(ele => {
      if (data[ele] === null || data[ele] === '') {
        /* global vm */
        vm.$delete(data, ele)
      }
    })
    return fetch.getLabOrderList(data).then(res => {
      return getTotalNumber(res)
    })
  },
  excludeTask (ctx, data) {
    let arr = Object.keys(data)
    arr.forEach(ele => {
      if (data[ele] === null || data[ele] === '') {
        /* global vm */
        vm.$delete(data, ele)
      }
    })
    // 暂时的参数
    data.targetStatus = data.targetStatus === 'LAB_INDEX_PLATOON' ? 'CHIP_SLOT' : data.targetStatus
    return fetch.excludeTask(data).then(res => {
      return getTotalNumber(res)
    })
  },
  geneOrderStatusUpdate (ctx, data) {
    return fetch.geneOrderStatusUpdate(data).then(res => {
      return res
    })
  },
  getOrderIsProcess (ctx, data) {
    return fetch.getOrderIsProcess(data).then(res => {
      return res.data
    })
  },
  geneOrderStatusUpdateWithoutAttachment (ctx, data) {
    return fetch.geneOrderStatusUpdateWithoutAttachment(data).then(res => {
      return res
    })
  },
  getGeneLabOrders (ctx, data) {
    return fetch.getGeneLabOrders(data).then(res => {
      return res
    })
  },
  getLabOrderStatusDetail (ctx, data) {
    return fetch.getLabOrderStatusDetail(data).then(res => {
      return res
    })
  },
  getLabOrderDetail (ctx, id) {
    return fetch.getLabOrderDetail(id).then(res => {
      let { bill, order, status, tasks, logs, sampleRecollectLogs } = res.data
      order = billDatas.formatSampleDetail(order)
      logs = logs && logs.sort(compare('operationTime'))
      // logs.forEach(e => {
      //   e.orderStatusResult = formatOperationLog(e.orderStatusResult)
      // })

      let task = null
      // 将tasks写到最新状态的childStatus字段内
      /* global _ */
      if (_.isArray(tasks) && tasks.length > 0) {
        task = tasks[0]
      }
      return {
        bill,
        order,
        status,
        task,
        logs,
        sampleRecollectLogs,
        tasks
      }
    })
  },
  getLabOrder (ctx, id) {
    return fetch.getLabOrder(id).then(res => {
      return res
    })
  },
  orderHandleList (ctx, data) {
    return fetch.orderHandleList(data).then(res => {
      res.data.forEach(ele => {
        // 样本类型
        if (ele.orderActionData && ele.orderActionData.order && ele.orderActionData.order.currentSample &&
                    ele.orderActionData.order.currentSample.sampleType) {
          ele.orderActionData.order.currentSample.sampleType = getEnumeration(ele.orderActionData.order.currentSample.sampleType, sampleType)
        }
        // 当前状态
        if (ele.orderActionData.action) {
          // 这两行顺序不能颠倒
          ele.orderActionData.nextAction = orderflowHelper.formatOrderActions(ele.orderActionData.action)
          ele.orderActionData.action = orderflowHelper.formatTargetOrderStatus(ele.orderActionData.action)
        }
        // 提交时间
        if (ele.createdDate) {
          ele.createdDate = formatDate(ele.createdDate)
        }
        //
      })
      return getTotalNumber(res)
    })
  },
  uploadTempFile (ctx, data) {
    return fetch.uploadTempFile(data).then(res => {
      return res
    })
  },
  geneOrderStatusUpdateNoFile (ctx, data) {
    return fetch.geneOrderStatusUpdateNoFile(data).then(res => {
      return res
    })
  },
  ossUploadBigFile (ctx, data) {
    let file = data.file
    let fileName = data.fileName
    let fileNameNoUrl = data.fileNameNoUrl
    return fetch.ossUploadBigFile(data).then(res => {
      let resData = res.data
      let uploadParams = new FormData()
      if (resData.accessid) {
        uploadParams.append('OSSAccessKeyId', resData.accessid)
      }
      if (resData.policy) {
        uploadParams.append('policy', resData.policy)
      }
      if (resData.signature) {
        uploadParams.append('Signature', resData.signature)
      }
      if (resData.path) {
        uploadParams.append('key', resData.path)
      } else if (fileName) {
        uploadParams.append('key', fileName)
      } else if (fileNameNoUrl) {
        uploadParams.append('key', resData.dir + '/' + new Date().getTime() + '-' + fileNameNoUrl)
      }
      if (file) {
        uploadParams.append('file', file)
      }
      if (resData.resource) {
        uploadParams.append('resource', resData.resource)
      }
      // uploadParams.append('success_action_status', 200) // 指定返回的状态码，默认为204
      return fetch.getSignature(resData.host, uploadParams).then(res => {
        if (resData.path) {
          res.fileNameNoUrl = resData.path
        } else if (fileNameNoUrl) {
          res.fileNameNoUrl = resData.dir + '/' + new Date().getTime() + fileNameNoUrl
        }
        return res
      })
      //   return res
    })
  },
  getSpecialOrderCount (ctx) {
    return fetch.getSpecialOrderCount().then(res => {
      return res.data
    })
  },
  pendingTasksSubmit (ctx, data) {
    return fetch.pendingTasksSubmit(data).then(res => {
      return res
    })
  },
  labTestPlatformList (ctx, data) {
    return fetch.labTestPlatformList(data).then(res => {
      res.data.forEach(ele => {
        if (!data.notFormat) {
          ele.createdDate = formatDate(ele.createdDate)
          if (ele.testCycle) {
            ele.testCycle = ele.testCycle.replace(/[^0-9]/ig, '')
          }
        }
      })
      return getTotalNumber(res)
    })
  },

  methodAdd (ctx, data) {
    return fetch.methodAdd(data).then(res => {
      return res
    })
  },
  methodDelete (ctx, id) {
    return fetch.methodDelete(id).then(res => {
      return res
    })
  },
  methodUpdate (ctx, data) {
    return fetch.methodUpdate(data).then(res => {
      return res.data
    })
  },

  getMethod (ctx, id) {
    return fetch.getMethod(id).then(res => {
      return res.data
    })
  },
  getGeneLabOrdersTargetStatus (ctx, data) {
    return fetch.getGeneLabOrdersTargetStatus(data).then(res => {
      return res
    })
  },
  labOrderFuzzy (ctx, data) {
    return fetch.labOrderFuzzy(data).then(res => {
      return getTotalNumber(res)
    })
  },
  exportLabOrders (ctx, data) {
    return fetch.exportLabOrders(data).then(res => {
      let message = '请稍后到“导出历史”页面查看'
      return message
    })
  },
  downloadRawData (ctx, data) {
    return fetch.downloadRawData(data).then(res => {
      let message = '请稍后到“导出历史”页面查看'
      return message
    })
  },
  getOrganizations (ctx) {
    return fetch.getOrganizations().then(res => {
      return res.data
    })
  },
  getTemplateList (ctx, data) {
    return fetch.getTemplateList(data).then(res => {
      return res.data
    })
  },
  editLabOrder (ctx, data) {
    return fetch.editLabOrder(data).then(res => {
      return res.data
    })
  },
  createdMaterialsLot (ctx, data) {
    return fetch.createdMaterialsLot(data).then(res => {
      return res.data
    })
  },
  creatLabOrder (ctx, data) {
    data.workflow = 'LAB_ORDER_CREATED'
    return fetch.creatLabOrder(data).then(res => {
      return res.data
    })
  },
  creatRecollectLabOrder (ctx, data) {
    data.workflow = 'LAB_ORDER_RECOLLECT'
    return fetch.creatLabOrder(data).then(res => {
      return res.data
    })
  },
  uploadReport (ctx, data) {
    return fetch.uploadReport(data).then(res => {
      return res.data
    })
  },
  downloadReport (ctx, data) {
    return fetch.downloadReport(data).then(res => {
      // let result = downloadFilename(res)
      let message = '请稍后到“导出历史”页面查看'
      return message
    })
  },
  uploadReports (ctx, data) {
    return fetch.uploadReports(data).then(res => {
      return res
    })
  },
  getBusinessArea (ctx) {
    return fetch.getBusinessArea().then(res => {
      return res.data
    })
  },
  getPackages (ctx) {
    return fetch.getPackages().then(res => {
      let result = getTotalNumber(res)
      let PackageList = []
      result.data.forEach((item, index) => {
        let single = {
          label: item.name,
          value: item.id
        }
        PackageList.push(single)
      })
      ctx.commit('detectionPackageList', PackageList)
      return getTotalNumber(res)
    })
  },
  orderBatchReview (ctx, data) {
    return fetch.orderBatchReview(data).then(res => {
      return res.data
    })
  },
  boardBatchReview (ctx, data) {
    return fetch.boardBatchReview(data).then(res => {
      return res.data
    })
  },
  getHistoryChipList (ctx, data) {
    return fetch.getHistoryChipList(data).then(res => {
      res.data.forEach(ele => {
        if (ele.chipModel) {
          ele.changeCreateTime = ele.createTime ? formatDate(ele.createTime) : ''
          ele.remainNum = Number(ele.chipModel && ele.chipModel.attributes ? ele.chipModel.attributes.total : '') - Number(ele.assignedNumber)
          ele.createdDateCopy = ele.createTime ? formatDate(ele.createTime) : ''
        } else {
          ele.chipModel = {}
          ele.chipModel.attributes = ele.attributes
          ele.assignedNumber = ele.slots.length
          ele.remainNum = Number(ele.chipModel && ele.chipModel.attributes ? ele.chipModel.attributes.total : '') - Number(ele.assignedNumber)
        }
      })
      return getTotalNumber(res)
    })
  },
  getChipHasSlots (ctx, data) {
    return fetch.getChipHasSlots(data).then(res => {
      res.data.forEach(ele => {
        if (ele.chipModel) {
          ele.changeCreateTime = ele.createTime ? formatDate(ele.createTime) : ''
          ele.remainNum = Number(ele.chipModel ? ele.chipModel.attributes.total : '') - Number(ele.assignedNumber)
          ele.createdDateCopy = ele.createTime ? formatDate(ele.createTime) : ''
        } else {
          ele.chipModel = {}
          ele.chipModel.attributes = ele.attributes
          ele.assignedNumber = ele.slots ? ele.slots.length : ''
          ele.remainNum = Number(ele.chipModel && ele.chipModel.attributes ? ele.chipModel.attributes.total : '') - Number(ele.assignedNumber)
        }
      })
      return getTotalNumber(res)
    })
  },
  getChipHasSlotsPlate (ctx, data) {
    return fetch.getChipHasSlotsPlate(data).then(res => {
      res.data.forEach(ele => {
        if (ele.chipModel) {
          ele.changeCreateTime = ele.createTime ? formatDate(ele.createTime) : ''
          ele.remainNum = Number(ele.chipModel ? ele.chipModel.attributes.total : '') - Number(ele.assignedNumber)
          ele.createdDateCopy = ele.createTime ? formatDate(ele.createTime) : ''
        } else {
          ele.chipModel = {}
          ele.chipModel.attributes = ele.attributes
          ele.assignedNumber = ele.slots ? ele.slots.length : ''
          ele.remainNum = Number(ele.chipModel && ele.chipModel.attributes ? ele.chipModel.attributes.total : '') - Number(ele.assignedNumber)
        }
      })
      return getTotalNumber(res)
    })
  },
  getHistoryChipListDetail (ctx, id) {
    return fetch.getHistoryChipListDetail(id).then(res => {
      return res.data
    })
  },
  getHistoryChipListSearch (ctx, id) {
    return fetch.getHistoryChipListSearch(id).then(res => {
      res.data.forEach(ele => {
        ele.changeCreateTime = formatDate(ele.createTime)
        ele.remainNum = Number(ele.chipModel.attributes.total) - Number(ele.assignedNumber)
        ele.createdDateCopy = ele.createTime && formatDate(ele.createTime)
      })
      return getTotalNumber(res)
    })
  },
  getChipDescriptionList (ctx, id) {
    return fetch.getChipDescriptionList(id).then(res => {
      res.data.forEach(element => {
        element.chengeCreateTime = formatDate(element.createTime)
      })
      return getTotalNumber(res)
    })
  },
  getChipDescriptionListSearch (ctx, id) {
    return fetch.getChipDescriptionListSearch(id).then(res => {
      res.data.forEach(element => {
        element.chengeCreateTime = formatDate(element.createTime)
      })
      return getTotalNumber(res)
    })
  },
  createChipDescription (ctx, id) {
    return fetch.createChipDescription(id).then(res => {
      return res.data
    })
  },
  updateChipDescription (ctx, id) {
    return fetch.updateChipDescription(id).then(res => {
      return res.data
    })
  },
  getChipDescriptionDetail (ctx, id) {
    return fetch.getChipDescriptionDetail(id).then(res => {
      return res.data
    })
  },
  getLabProductLine (ctx) {
    return fetch.getLabProductLine().then(res => {
      return res.data
    })
  },
  deleteLabOrder (ctx, id) {
    return fetch.deleteLabOrder(id).then(res => {
      return res.data
    })
  },
  closeLabOrder (ctx, id) {
    return fetch.closeLabOrder(id).then(res => {
      return res.data
    })
  },
  getHistoryChipDeatil (ctx, id) {
    return fetch.getHistoryChipDeatil(id).then(res => {
      return res.data
    })
  },
  createChipMaterial (ctx, data) {
    return fetch.createChipMaterial(data).then(res => {
      return res.data
    })
  },
  getAssignedData (ctx, id) {
    return fetch.getAssignedData(id).then(res => {
      return res.data
    })
  },
  batchList (ctx, data) {
    return fetch.batchList(data).then(res => {
      return getTotalNumber(res)
    })
  },
  downloadExcel (ctx, id) {
    return fetch.downloadExcel(id).then(res => {
      creatDownload(res.data)
      return res
    })
  },
  downloadChipHistoryExcel (ctx, id) {
    return fetch.downloadChipHistoryExcel(id).then(res => {
      creatDownload(res.data)
      return res
    })
  },
  downloadTestExcel (ctx) {
    return fetch.downloadTestExcel().then(res => {
      creatDownload(res.data)
      return res
    })
  },
  handleSettle (ctx, data) {
    return fetch.handleSettle(data).then(res => {
      return res.data
    })
  },
  getStandard (ctx, str) {
    return fetch.getStandard(str).then(res => {
      return res.data
    })
  },
  getAmplificationStandard (ctx, str) {
    return fetch.getAmplificationStandard(str).then(res => {
      return res.data
    })
  },
  getHolidays (ctx, data) {
    return fetch.getHolidays(data).then(res => {
      return getTotalNumber(res)
    })
  },
  createHoliday (ctx, data) {
    return fetch.createHoliday(data).then(res => {
      return res.data
    })
  },
  editHoliday (ctx, data) {
    return fetch.editHoliday(data).then(res => {
      return res.data
    })
  },
  deleteHoliday (ctx, id) {
    return fetch.deleteHoliday(id).then(res => {
      return res.data
    })
  },
  deleteHolidays (ctx, ids) {
    return fetch.deleteHolidays(ids).then(res => {
      return res.data
    })
  },
  getHoliday (ctx, ids) {
    return fetch.getHoliday(ids).then(res => {
      return res.data
    })
  },
  importHoliday (ctx, data) {
    return fetch.importHoliday(data).then(res => {
      return res.data
    })
  },
  createMultipleChip (ctx, data) {
    return fetch.createMultipleChip(data).then(res => {
      return res.data
    })
  },
  exportConciseExcel (ctx, data) {
    return fetch.exportConciseExcel(data).then(res => {
      let message = '请稍后到“导出历史”页面查看'
      return message
    })
  },
  addAbnormalReason (ctx, data) {
    return fetch.addAbnormalReason(data).then(res => {
      return res.data
    })
  },
  getAbnormalReason (ctx, data) {
    return fetch.getAbnormalReason(data).then(res => {
      return res.data
    })
  },
  getOrderWorkFlow (ctx, data) {
    return fetch.getOrderWorkFlow(data).then(res => {
      return res.data
    })
  },
  getWorkFlowRecollect (ctx, data) {
    return fetch.getWorkFlowRecollect(data).then(res => {
      return res.data
    })
  },
  sampleBoardCanUseList (ctx, data) {
    return fetch.sampleBoardCanUseList(data).then(res => {
      res.data.forEach(ele => {
        ele.rootReactionPlateName = ele.isRoot ? ele.name : ele.rootReactionPlateName
        ele.name = ele.isRoot ? '--' : (ele.name.indexOf('__') > -1 ? (ele.chipId ? ele.chipId : '--') : ele.name)
        if (ele.nextOrderAction === 'LAB_SAMPLES_RECEIVED' || ele.rootReactionPlateName === null) {
          ele.processBoard = ele.name ? ele.name : '--'
        } else {
          ele.processBoard = ele.processSamplePlates ? ele.processSamplePlates : '--'
        }
        ele.status = ele.status ? orderflowHelper.formatOrderActions(ele.status) : '--'
        ele.plateType = ele.plateType ? getPlateType(ele.plateType) : '--'
        ele.createdDate = ele.createdDate ? formatDate(ele.createdDate, 'default') : '--'
      })
      return getTotalNumber(res)
    })
  },
  getSamplesjobRecord (ctx, data) {
    return fetch.getSamplesjobRecord(data).then(res => {
      return res.data
    })
  },
  getSamplesjobRecords (ctx, ids) {
    return fetch.getSamplesjobRecords(ids).then(res => {
      return res.data
    })
  },
  getSamplesjobRecordAll (ctx, data) {
    return fetch.getSamplesjobRecordAll(data).then(res => {
      res.data.forEach(ele => {
        ele.startTime = ele.startTime ? formatDate(ele.startTime) : ''
      })
      return getTotalNumber(res)
    })
  },
  getSamplesjobRecordError (ctx, data) {
    return fetch.getSamplesjobRecordError(data).then(res => {
      return res.data
    })
  },
  getSamplesjobRecordPending (ctx, data) {
    return fetch.getSamplesjobRecordPending(data).then(res => {
      return res.data
    })
  },
  getOrderCountStatistical (ctx, data) {
    return fetch.getOrderCountStatistical(data).then(res => {
      return res.data
    })
  },
  getTrendStatistics (ctx, data) {
    return fetch.getTrendStatistics(data).then(res => {
      return res.data
    })
  },
  getLabProductByClients (ctx, data) {
    return fetch.getLabProductByClients(data).then(res => {
      return res.data
    })
  },
  getSAMPLETYPE (ctx, data) {
    return fetch.getSAMPLETYPE(data).then(res => {
      return res.data
    })
  },
  getSampleTypeList (ctx, data) {
    return fetch.getSampleTypeList(data).then(res => {
      return getTotalNumber(res)
    })
  },
  getSampleTypeSave (ctx, data) {
    return fetch.getSampleTypeSave(data).then(res => {
      return res.data
    })
  },
  getSampleTypeEdit (ctx, data) {
    return fetch.getSampleTypeEdit(data).then(res => {
      return res.data
    })
  },
  getSampleTypeDelete (ctx, data) {
    return fetch.getSampleTypeDelete(data).then(res => {
      return res.data
    })
  },
  getSampleTypeDetail (ctx, data) {
    return fetch.getSampleTypeDetail(data).then(res => {
      return res.data
    })
  },
  getDefaultLayout (ctx, data) {
    return fetch.getDefaultLayout(data).then(res => {
      return res.data
    })
  },
  getOrderExportExcel (ctx, data) {
    return fetch.getOrderExportExcel(data).then(res => {
      return res.data
    })
  },
  createBatchOrder (ctx, data) {
    return fetch.createBatchOrder(data).then(res => {
      return res
    })
  },
  updateBatchTaskStatus (ctx, data) {
    return fetch.updateBatchTaskStatus(data).then(res => {
      return res
    })
  },
}
